import React from 'react';
import NewFooter from '../Components/NewFooter';
import PortalButton from '../Components/PortalButton';
import Logo from '../Components/Logo/Logo';
import ForgotPasswordModal from '../Components/ResetPasswordModal';
import styles from './Layout.module.scss';
import LandingImg from '../../images/venza-landing-img.png';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

type LayoutVariant = 'split' | 'centered';

interface LayoutProps {
	children?: React.ReactNode;
	variant?: LayoutVariant;
	showPortalBtn?: boolean;
	showResetPassModal?: boolean;
	setShowResetPassModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RightPanel = ({ t } : { t: TFunction }) => (
	<div className={styles.rightContainer}>
		<div className={styles.svgContainer}>
			{/* <Icon type="venzaLanding" /> */}
			<img src={LandingImg} alt='landing-img'/>
		</div>
		<div className={styles.contentContainer}>
			<h1 className={styles.heading}>{t('auth.layout.sidePanelTitle')}</h1>
			<p className={styles.description}>{t('auth.layout.sidePanelDescription')}</p>
		</div>
	</div>
);

export default function NewAuthLayout({
	children,
	variant = 'split',
	showPortalBtn = false,
	showResetPassModal = false,
	setShowResetPassModal
}: LayoutProps) {
	const { t } = useTranslation();

	return (
		<div className={`${styles.root} ${styles[variant]}`}>
			<div className={styles.mainContent}>
				{variant === 'split' && (
					<>
						<div className={styles.leftInner}>
							<div className={styles.leftContainer}>
								<div className={styles.logoWrap}>
									<Logo />
								</div>
								{children}
							</div>
						</div>
						<RightPanel t={t} />
					</>
				)}

				{variant === 'centered' && (
					<div className={styles.centeredContainer}>
						<div className={styles.logoWrap}>
							<Logo />
						</div>
						{children}
					</div>
				)}
			</div>
			<div className={styles.bottomBar}>
				{showPortalBtn && <PortalButton t={t} />}
				{setShowResetPassModal && (
					<>
						<ForgotPasswordModal
							visible={showResetPassModal}
							onCancel={() => setShowResetPassModal(false)}
						/>
					</>
				)}
				<NewFooter
					t={t}
					isAdminLogin={showPortalBtn}
					setShowResetPassword={setShowResetPassModal}
				/>
			</div>
		</div>
	);
}
